import React from 'react';
import classnames from 'classnames';

interface LicenseDetailSectionProps {
  className?: string;
  title?: React.ReactNode;
  children?: React.ReactNode;
}

const LicenseDetailSection = ({
  className = '',
  title = '',
  children,
}: LicenseDetailSectionProps): React.JSX.Element => (
  <div className={classnames('display-flex flex-column', className)}>
    <div className="font-bold margin-bottom-sm">{title}</div>
    <div>{children}</div>
  </div>
);

export default LicenseDetailSection;
